<template>
    <div class="home-footer">
        <div
            class="agent-info-wrapper border-top border-bottom d-none d-md-flex mx-auto"
            :style="{'background-image': 'url(' + backgroundSrc + ')'}"
        >
            <agent-card
                class="m-auto"
                :avatar="landingPage.avatar"
                :display-name="displayName"
                :occupation="'Real Estate Agent'"
                :email="landingPage.email"
                :company-logo="companyLogo"
                :phones="landingPage.phones.toArray()"
                :social-links="landingPage.socialLinks.toArray()"
            />
        </div>

        <agent-card
            class="m-auto d-block d-md-none border-0"
            :avatar="landingPage.avatar"
            :display-name="displayName"
            :occupation="'Real Estate Agent'"
            :email="landingPage.email"
            :company-logo="companyLogo"
            :phones="landingPage.phones.toArray()"
            :social-links="landingPage.socialLinks.toArray()"
        />
    </div>
</template>

<script>
    import "./HomeFooter.scss";
    import AgentCard from "../../AgentCard/AgentCard";
    import {mapBackgroundImage} from "../../../../helpers/methods";
    import LandingPageAppResource from "@milestoneslabs/milestones-core-js/src/AppResources/LandingPageAppResource";
    import get from "lodash/get";

    export default {
        name: "HomeFooter",
        components: {AgentCard},

        props: {
            landingPage: {
                type: LandingPageAppResource,
                required: true,
            },
            backgroundImageField: {
                type: String,
                required: true,
            }
        },

        computed: {
            companyLogo() {
                return (this.landingPage.organizationLogo || {}).publicStorageUrl || null;
            },

            displayName() {
                return this.landingPage.displayName || this.landingPage.firstName + ' ' + this.landingPage.lastName;
            },

            backgroundSrc() {
                return get(this.landingPage, this.backgroundImageField, null)
                    || mapBackgroundImage(this.landingPage.landingPageType.slug);
            },
        }
    };
</script>
